import { cn } from "@/lib/utils";
import { contentLabelsSelector } from "@/redux/loadedContent/loadedContentSlice";
import { useSelector } from "react-redux";

import { rolesPlusIcon } from "../../../designSystemIcons";

type Props = {
  plus: boolean;
  plusPlus: boolean;
  position?: string;
  withBackground?: boolean;
};

export const PlusPlus = ({
  plus,
  plusPlus,
  withBackground,
  position,
}: Props) => {
  const { positions } = useSelector(contentLabelsSelector);
  return plus || plusPlus ? (
    <div className="flex flex-row items-center gap-x-2">
      {position && (
        <span className="-mr-1 text-gray-200">
          ({positions[position]?.name ?? position})
        </span>
      )}
      {plusPlus ? (
        <div
          className={cn(
            "flex flex-row gap-x-1",
            withBackground && "px-1 py-1.5 bg-gray-800 rounded",
          )}
        >
          <span className="w-[7px] h-[7px] touch-device:w-[10px] touch-device:h-[10px]">
            {rolesPlusIcon}
          </span>
          <span className="w-[7px] h-[7px] touch-device:w-[10px] touch-device:h-[10px]">
            {rolesPlusIcon}
          </span>
        </div>
      ) : plus ? (
        <div
          className={cn(
            "flex flex-row gap-x-1",
            withBackground && "px-1 py-1.5 bg-gray-800 rounded",
          )}
        >
          <span className="w-[7px] h-[7px] touch-device:w-[10px] touch-device:h-[10px]">
            {rolesPlusIcon}
          </span>
        </div>
      ) : null}
    </div>
  ) : null;
};
